/**
 * Converts a number of decimal places to a step value for use in input fields.
 */
export function decimalToStep(decimalPlaces: string | number) {
  return 1 / Math.pow(10, Number(decimalPlaces === '' ? 2 : decimalPlaces));
}
